export const getUserName = (user) => {
  user = user || {};
  if (user.first_name) return `${user.first_name} ${user.last_name}`;
  if (user.username) return user.username;
  return user.id || null;
};

export const getUserInitials = (user) => {
  user = user || {};
  if (user.first_name && user.last_name)
    return `${user.first_name[0]}${user.last_name[0]}`;
  if (user.username)
    return `${user.username.charAt(0).toUpperCase()}${user.username.charAt(1)}`;
  return '??';
};

export const generateColor = (username) => {
  username = username || {};
  let hash = 0;
  for (let i = 0; i < username?.length; i++) {
    hash = username?.charCodeAt(i) + ((hash << 5) - hash);
  }
  let h = hash % 360;
  return 'hsl(' + h + ', ' + 30 + '%, ' + 50 + '%)';
};
